import { Button } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { isUndefined } from 'lodash'
import { useEffect, useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import Light from '../../../assets/icons/Light.svg?react'
import { useWrapperStore } from '../../../store/storeWrapper'
import MarkdownEditor from '../../InternalPage/RequestMessagesPage/components/MarkdownEditor'

export const AssistantPayPage = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const {
        setCurrentAgentAndAssistantIdDialog,
        setCurrentAssistantDataInDialog,
        setStateNotification,
        setScrollToRequestInput,
        assistantSubscriptions,
        fetchAssistantSubscriptions,
        fetchAssistantDetail,
        assistantsDetail: assistant,
        checkIsFreeAssistant,
        freeAssistant,
        buyAssistantSubscription,
        isTempUser,
        isLoadingFetchOperationAssistantSubscription,
        isBuyAssistantSubscription,
        errorFetchOperationAssistantSubscription,
    } = useWrapperStore((state) => state)

    useEffect(() => {
        fetchAssistantDetail(searchParams.get('id'), searchParams.get('language'))
        fetchAssistantSubscriptions()
        checkIsFreeAssistant(searchParams.get('id'))
    }, [searchParams])

    useLayoutEffect(() => {
        if (isBuyAssistantSubscription) {
            window.open(
                `arhiassistantapp://assistant-pay/success`,
                '_self',
            )
        } else if (errorFetchOperationAssistantSubscription) {
            window.open(
                `arhiassistantapp://assistant-pay/failed`,
                '_self',
            )
        }
    }, [isBuyAssistantSubscription, errorFetchOperationAssistantSubscription])

    const handleSubmitAssistantInfoDialog = async () => {
        await buyAssistantSubscription(searchParams.get('id'))
    }

    return (
        <>
            {!errorFetchOperationAssistantSubscription &&
                !isBuyAssistantSubscription &&
                assistant && (
                    <>
                        <Stack
                            sx={{
                                padding: '4px',
                                overflowY: 'scroll',
                                maxHeight: 'calc(100dvh - 128px)',
                            }}>
                            <Typography variant="h3" sx={{ fontSize: '20px' }}>
                                {t('assistantPay.assistantTitle', { name: assistant.name })}
                            </Typography>
                            <MarkdownEditor
                                text={assistant?.full_description.replaceAll('---\n', '')}
                            />
                            <Stack
                                sx={{
                                    borderRadius: '12px',
                                    background: ' #F6F6F6',
                                    display: 'flex',
                                    padding: '8px',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    alignSelf: 'stretch',
                                }}>
                                <MarkdownEditor text={assistant?.example.replaceAll('---\n', '')} />
                            </Stack>
                            <Stack direction="row" spacing={1} mt={2} sx={{ alignItems: 'center' }}>
                                <Light width="24px" />
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        lineHeight: '20px',
                                        mb: 3,
                                    }}>
                                    {assistant?.based_on}
                                </Typography>
                            </Stack>

                            <Typography
                                mt={3}
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    lineHeight: '20px',
                                    color: '#5A5C5E',
                                    fontStyle: 'italic',
                                }}>
                                {assistant?.disclamer}
                            </Typography>
                        </Stack>
                        <Stack
                            sx={{
                                padding: '12px',
                                width: ' 100%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                position: 'fixed',
                                bottom: '0',
                                background: '#f9fafb',
                            }}
                            spacing={1}>
                            {!isUndefined(freeAssistant) && (
                                <Button
                                    disabled={isLoadingFetchOperationAssistantSubscription}
                                    sx={{
                                        display: 'flex',
                                        minHeight: '56px',
                                        padding: '0 24px',
                                        justifyContent: 'center',
                                        borderRadius: '12px',
                                        background: '#006CFD',
                                    }}
                                    variant="contained"
                                    onClick={handleSubmitAssistantInfoDialog}
                                    fullWidth>
                                    {freeAssistant
                                        ? t('assistantPay.connect')
                                        : t('assistantPay.connectForPrice', { price: assistant?.price })}
                                </Button>
                            )}

                            {freeAssistant && (
                                <Typography
                                    variant="body2"
                                    sx={{ textAlign: 'center', color: '#5A5C5E' }}>
                                    {t('assistantPay.freeFirstMonth')}
                                </Typography>
                            )}
                        </Stack>
                    </>
                )}
            {isBuyAssistantSubscription && (
                <Stack
                    sx={{
                        padding: '4px',
                    }}>
                    <Typography variant="h3" sx={{ fontSize: '20px' }}>
                        {t('assistantPay.successTitle')}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                        {t('assistantPay.successDescription')}
                    </Typography>
                </Stack>
            )}

            {errorFetchOperationAssistantSubscription && (
                <Stack
                    sx={{
                        padding: '4px',
                    }}>
                    <Typography variant="h3" sx={{ fontSize: '20px' }}>
                        {t('assistantPay.errorTitle')}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                        {t('assistantPay.errorDescription')}
                    </Typography>
                </Stack>
            )}
        </>
    )
}
